import React from "react";
import { useNavigate } from "react-router-dom";
import { useRole } from "../../../hooks/useRole";
import { FUND_TERMS_ROLES } from "./fundTermsModel";

/**
 * FundTermsEntry - the campaign view's way into the Fund terms screen (R4,
 * Friday release 2026-10-09; decision D7). CampaignViewPage renders it in its
 * FUND branch only. It is offered to the seats the API admits
 * (requireRole('AD', 'CCO') on every fund terms call); the server still
 * decides, and the screen renders its refusal.
 *
 * useRole().hasRole carries the legacy Super Admin wildcard, mirroring the
 * server's requireRole legacy path.
 */
export default function FundTermsEntry({ campaignId }) {
  const { hasRole } = useRole();
  const navigate = useNavigate();
  if (!campaignId || !hasRole(...FUND_TERMS_ROLES)) return null;
  return (
    <div className="detailItem">
      <span className="itemKey">Fund terms:</span>
      <span className="itemValue">
        <button type="button" className="editButton" onClick={() => navigate(`/fund-terms/${campaignId}`)}>
          Open fund terms
        </button>
      </span>
    </div>
  );
}
